export default __webpack_public_path__ + "static/media/vscode.feab1f2b.svg";